import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../shared/loader/loader.service';
import { LocalstorageService } from '../shared/localstorage/localstorage.service';

export class HttpRequestModel {
  header: string;
  url: string;
  method: string;
  params: any;
  body: any;
  formType: any;
  token: any;
  responseType: string;
  observe: string;

  reset() {
    Object.keys(this).forEach(key => {
      this[key] = '';
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  baseUrl = environment.baseUrl;

  headers = new HttpHeaders({
    AuthToken: environment.authToken,
  });
  multipartHeaders = new HttpHeaders({
    AuthToken: environment.authToken,
    'Content-Type': 'multipart/form-data',
  });

  constructor(
    private http: HttpClient,
    private localStorageService: LocalstorageService,
    private loader: LoaderService,
  ) {}

  /**
   * Before any Request.
   */
  private beforeRequest(doShowLoader): void {
    if (doShowLoader) {
      this.loader.displayLoader();
    }
  }

  /**
   * After any request.
   */
  private afterRequest(): void {
    this.loader.hideLoader();
  }

  /**
   * Request options.
   * @param options
   * @returns {RequestOptionsArgs}
   */
  private requestOptions(httpRequest: HttpRequestModel) {
    const options = httpRequest as unknown as Record<string, unknown>;

    if (httpRequest.formType == 'multipart') {
      options.headers = this.headers;
    } else {
      options.headers = this.headers;
    }

    options.withCredentials = true;

    return options;
  }

  init(httpRequest: HttpRequestModel, doShowLoader = false, doHideloader = false): Observable<any> {
    const options = this.requestOptions(httpRequest);

    return this.request(this.baseUrl + httpRequest.url, options, doShowLoader, doHideloader);
  }

  request(url: string, option, doShowLoader = false, doHideloader = false): Observable<any> {
    this.beforeRequest(doShowLoader);
    return this.http.request(option.method, url, option).pipe(map(response => this.onSuccess(response, doHideloader)));
  }

  /*
   * onSuccess
   * @param res
   */
  private onSuccess(res, doHideloader) {
    if (doHideloader) {
      this.afterRequest();
    }

    return res;
  }
}
